import React from 'react';

import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';

import { valueOrHyphen } from '../../lib/utils';

interface TruncatedValueProps {
  value?: string;
}

function TruncatedValue({ value = undefined }: TruncatedValueProps): React.JSX.Element {
  if (!value) {
    return <React.Fragment>{valueOrHyphen(value)}</React.Fragment>;
  }

  return (
    <TruncatedText
      hasTruncation
      tooltipContent={value}
    >
      {value}
    </TruncatedText>
  );
}

export { TruncatedValue };
